import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  AppBar,
  Toolbar,
  Button,
  Avatar,
  Menu,
  MenuItem,
  Tabs,
  Tab,
  Paper,
} from '@mui/material';
import {
  CloudUpload as UploadIcon,
  Search as SearchIcon,
  History as HistoryIcon,
  AccountCircle as ProfileIcon,
  ExitToApp as LogoutIcon,
  Feedback as FeedbackIcon,
} from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import UploadSection from '../Upload/UploadSection';
import SearchInterface from '../Search/SearchInterface';
import QueryHistory from '../History/QueryHistory';

const Dashboard = () => {
  const { user, logout } = useAuth();
  const [currentTab, setCurrentTab] = useState(0);
  const [profileMenuAnchor, setProfileMenuAnchor] = useState(null);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handleProfileMenuOpen = (event) => {
    setProfileMenuAnchor(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setProfileMenuAnchor(null);
  };

  const handleLogout = () => {
    handleProfileMenuClose();
    logout();
  };

  const renderTabContent = () => {
    switch (currentTab) {
      case 0:
        return <SearchInterface />;
      case 1:
        return <UploadSection />;
      case 2:
        return <QueryHistory />;
      default:
        return <SearchInterface />;
    }
  };

  return (
    <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
      {/* App Bar */}
      <AppBar position="static" elevation={0} sx={{ backgroundColor: 'primary.main' }}>
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 600 }}>
            Marshmallow AI
          </Typography>
          
          {/* Feedback Button */}
          <Button
            color="inherit"
            startIcon={<FeedbackIcon />}
            onClick={() => window.open('https://forms.gle/tN8oC5Mf6hukKCMk6', '_blank')}
            sx={{ textTransform: 'none', mr: 2 }}
          >
            Feedback
          </Button>
          
          {/* User Profile */}
          <Button
            color="inherit"
            startIcon={
              <Avatar
                src={user?.profile_picture}
                sx={{ width: 32, height: 32 }}
              >
                {user?.name?.[0] || user?.email?.[0] || 'U'}
              </Avatar>
            }
            onClick={handleProfileMenuOpen}
            sx={{ textTransform: 'none' }}
          >
            {user?.name || user?.email}
          </Button>
          
          <Menu
            anchorEl={profileMenuAnchor}
            open={Boolean(profileMenuAnchor)}
            onClose={handleProfileMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuItem onClick={handleProfileMenuClose}>
              <ProfileIcon sx={{ mr: 1 }} />
              Profile
            </MenuItem>
            <MenuItem onClick={handleLogout}>
              <LogoutIcon sx={{ mr: 1 }} />
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {/* Navigation Tabs */}
      <Paper elevation={0} sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Container maxWidth="lg">
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            aria-label="dashboard navigation"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab
              label="Search"
              icon={<SearchIcon />}
              iconPosition="start"
              sx={{ textTransform: 'none', minHeight: 64 }}
            />
            <Tab
              label="Upload Data"
              icon={<UploadIcon />}
              iconPosition="start"
              sx={{ textTransform: 'none', minHeight: 64 }}
            />
            <Tab
              label="History"
              icon={<HistoryIcon />}
              iconPosition="start"
              sx={{ textTransform: 'none', minHeight: 64 }}
            />
          </Tabs>
        </Container>
      </Paper>

      {/* Main Content */}
      <Container maxWidth="lg" sx={{ py: 4 }}>
        {renderTabContent()}
      </Container>
    </Box>
  );
};

export default Dashboard;